import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n          Contract Details\n        ", -1);
const _hoisted_4 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_5 = { class: "col-span-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "contractType",
    class: "block text-sm font-medium text-gray-700"
}, "Contract Type *", -1);
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = ["value"];
const _hoisted_9 = ["value"];
const _hoisted_10 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_11 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_12 = { class: "col-span-6" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    for: "contractLevel",
    class: "block text-sm font-medium text-gray-700"
}, "Contract Level *", -1);
const _hoisted_14 = ["value", "disabled"];
const _hoisted_15 = ["value"];
const _hoisted_16 = ["value"];
const _hoisted_17 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 block text-sm font-medium text-red-500 italic" }, "\n                * Confirmation and approval of the contract level is subject to\n                change by the HR Approver.\n              ", -1);
const _hoisted_19 = { class: "grid grid-cols-3 gap-6 mt-4" };
const _hoisted_20 = {
    key: 0,
    class: "grid col-span-6"
};
const _hoisted_21 = { class: "mt-4" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Pension: ", -1);
const _hoisted_23 = { class: "mt-4" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Life Cover: ", -1);
const _hoisted_25 = { class: "mt-4" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Private Medical Insurance:\n                ", -1);
const _hoisted_27 = { class: "mt-4" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, " Car: ", -1);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_30 = {
    key: 0,
    class: "italic text-sm"
};
const _hoisted_31 = { class: "mt-4" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Bonus %: ", -1);
const _hoisted_33 = { class: "mt-4" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Overtime: ", -1);
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_36 = {
    key: 0,
    class: "italic text-sm"
};
const _hoisted_37 = { class: "mt-4" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Annual Leave Entitlement (Per Annum): ", -1);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_40 = { class: "mt-4" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Sickness: ", -1);
const _hoisted_42 = { class: "mt-4" };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Probation Period: ", -1);
const _hoisted_44 = { class: "mt-4" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("span", { class: "text-blue-700 font-bold" }, "Notice Period: ", -1);
const _hoisted_46 = {
    key: 0,
    class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5"
};
const _hoisted_47 = { class: "col-span-6" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                Please select your business need car requirement? *\n              ", -1);
const _hoisted_49 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_50 = { class: "mt-4 space-y-4" };
const _hoisted_51 = { class: "flex items-start" };
const _hoisted_52 = { class: "h-5 flex items-center" };
const _hoisted_53 = ["disabled", "checked"];
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "businessVehicle",
        class: "font-medium text-gray-700"
    }, "Car is required")
], -1);
const _hoisted_55 = { class: "flex items-start" };
const _hoisted_56 = { class: "h-5 flex items-center" };
const _hoisted_57 = ["disabled", "checked"];
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "businessVehicle",
        class: "font-medium text-gray-700"
    }, "Van is required")
], -1);
const _hoisted_59 = { class: "flex items-start" };
const _hoisted_60 = { class: "h-5 flex items-center" };
const _hoisted_61 = ["disabled", "checked"];
const _hoisted_62 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "businessVehicle",
        class: "font-medium text-gray-700"
    }, "Neither is required")
], -1);
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("div", { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" }, null, -1);
const _hoisted_64 = /*#__PURE__*/ _createElementVNode("label", {
    for: "bonusType",
    class: "text-base font-medium text-gray-900 block"
}, "Please confirm the bonus type *", -1);
const _hoisted_65 = ["value"];
const _hoisted_66 = ["value"];
const _hoisted_67 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_68 = { class: "col-span-6" };
const _hoisted_69 = /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                What is the proposed salary basis? *\n              ", -1);
const _hoisted_70 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_71 = { class: "mt-4 space-y-4" };
const _hoisted_72 = { class: "flex items-start" };
const _hoisted_73 = { class: "h-5 flex items-center" };
const _hoisted_74 = ["disabled", "checked"];
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "salaryBasis",
        class: "font-medium text-gray-700"
    }, "Per Annum")
], -1);
const _hoisted_76 = { class: "flex items-start" };
const _hoisted_77 = { class: "h-5 flex items-center" };
const _hoisted_78 = ["disabled", "checked"];
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "salaryBasis",
        class: "font-medium text-gray-700"
    }, "Per Hour")
], -1);
const _hoisted_80 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_81 = { class: "col-span-6 flex flex-col" };
const _hoisted_82 = /*#__PURE__*/ _createElementVNode("label", {
    for: "minimumPayRate",
    class: "block text-sm font-medium text-gray-700"
}, "What is the minimum proposed salary or hourly rate? *", -1);
const _hoisted_83 = { class: "flex" };
const _hoisted_84 = ["value", "disabled"];
const _hoisted_85 = ["value"];
const _hoisted_86 = /*#__PURE__*/ _createElementVNode("option", {
    value: "GBP",
    selected: ""
}, "GBP", -1);
const _hoisted_87 = /*#__PURE__*/ _createElementVNode("option", { value: "EUR" }, "EUR", -1);
const _hoisted_88 = /*#__PURE__*/ _createElementVNode("option", { value: "USD" }, "USD", -1);
const _hoisted_89 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_90 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_91 = { class: "col-span-6 flex flex-col" };
const _hoisted_92 = /*#__PURE__*/ _createElementVNode("label", {
    for: "maximumPayRate",
    class: "block text-sm font-medium text-gray-700"
}, "What is the maximum proposed salary or hourly rate? *", -1);
const _hoisted_93 = { class: "flex" };
const _hoisted_94 = ["value", "disabled"];
const _hoisted_95 = ["value"];
const _hoisted_96 = /*#__PURE__*/ _createElementVNode("option", {
    value: "GBP",
    selected: ""
}, "GBP", -1);
const _hoisted_97 = /*#__PURE__*/ _createElementVNode("option", { value: "EUR" }, "EUR", -1);
const _hoisted_98 = /*#__PURE__*/ _createElementVNode("option", { value: "USD" }, "USD", -1);
const _hoisted_99 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_100 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_101 = { class: "col-span-6" };
const _hoisted_102 = /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                Are there any additional allowances associated with this role? *\n              ", -1);
const _hoisted_103 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_104 = { class: "mt-4 space-y-4" };
const _hoisted_105 = { class: "flex items-start" };
const _hoisted_106 = { class: "h-5 flex items-center" };
const _hoisted_107 = ["disabled", "checked"];
const _hoisted_108 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "additionalAllowances",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1);
const _hoisted_109 = { class: "flex items-start" };
const _hoisted_110 = { class: "h-5 flex items-center" };
const _hoisted_111 = ["disabled", "checked"];
const _hoisted_112 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "additionalAllowances",
        class: "font-medium text-gray-700"
    }, "No")
], -1);
const _hoisted_113 = {
    key: 2,
    class: "mt-4 sm:border-t sm:border-gray-200 sm:pt-5"
};
const _hoisted_114 = { class: "col-span-6" };
const _hoisted_115 = { class: "flex justify-between" };
const _hoisted_116 = /*#__PURE__*/ _createElementVNode("label", {
    for: "specify",
    class: "block text-sm font-medium text-gray-700"
}, "Please Specify *", -1);
const _hoisted_117 = ["value", "onChange"];
const _hoisted_118 = /*#__PURE__*/ _createElementVNode("option", {
    selected: "selected",
    disabled: "true",
    value: "selected"
}, "\n                    Please select\n                  ", -1);
const _hoisted_119 = /*#__PURE__*/ _createElementVNode("option", { value: "Allowance" }, "Allowance", -1);
const _hoisted_120 = /*#__PURE__*/ _createElementVNode("option", { value: "First Aid" }, "First Aid", -1);
const _hoisted_121 = /*#__PURE__*/ _createElementVNode("option", { value: "Fixed Monthly Unsocial Allowance" }, "\n                    Fixed Monthly Unsocial Allowance\n                  ", -1);
const _hoisted_122 = /*#__PURE__*/ _createElementVNode("option", { value: "Flexable Allowance" }, "Flexable Allowance", -1);
const _hoisted_123 = /*#__PURE__*/ _createElementVNode("option", { value: "Honorarium (NTC" }, "Honorarium (NTC)", -1);
const _hoisted_124 = /*#__PURE__*/ _createElementVNode("option", { value: "London Allowance" }, "London Allowance", -1);
const _hoisted_125 = /*#__PURE__*/ _createElementVNode("option", { value: "Night Allowance" }, "Night Allowance", -1);
const _hoisted_126 = /*#__PURE__*/ _createElementVNode("option", { value: "On Call / Call Out" }, "On Call / Call Out", -1);
const _hoisted_127 = /*#__PURE__*/ _createElementVNode("option", { value: "Shift Allowance" }, "Shift Allowance", -1);
const _hoisted_128 = /*#__PURE__*/ _createElementVNode("option", { value: "Site Supplement" }, "Site Supplement", -1);
const _hoisted_129 = /*#__PURE__*/ _createElementVNode("option", { value: "Standby" }, "Standby", -1);
const _hoisted_130 = /*#__PURE__*/ _createElementVNode("option", { value: "Travel Allowance" }, "Travel Allowance", -1);
const _hoisted_131 = /*#__PURE__*/ _createElementVNode("option", { value: "Weekend Allowance" }, "Weekend Allowance", -1);
const _hoisted_132 = { class: "col-span-6 mt-2" };
const _hoisted_133 = { class: "flex" };
const _hoisted_134 = { class: "w-full" };
const _hoisted_135 = /*#__PURE__*/ _createElementVNode("label", {
    for: "additional-allowance-title",
    class: "block text-sm font-medium text-gray-700"
}, "Specify Value (per month)", -1);
const _hoisted_136 = ["value", "onInput"];
const _hoisted_137 = { class: "ml-2" };
const _hoisted_138 = /*#__PURE__*/ _createElementVNode("label", {
    for: "additional-allowance-title",
    class: "block text-sm font-medium text-gray-700"
}, "Currency:", -1);
const _hoisted_139 = ["value", "onChange"];
const _hoisted_140 = /*#__PURE__*/ _createElementVNode("option", {
    selected: "",
    value: "GBP"
}, "GBP", -1);
const _hoisted_141 = /*#__PURE__*/ _createElementVNode("option", { value: "EUR" }, "EUR", -1);
const _hoisted_142 = /*#__PURE__*/ _createElementVNode("option", { value: "USD" }, "USD", -1);
const _hoisted_143 = { class: "flex justify-end mt-4" };
const _hoisted_144 = { class: "grid grid-cols-3 gap-6 mt-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_145 = { class: "col-span-6" };
const _hoisted_146 = /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                What is the payroll frequency for this role? *\n              ", -1);
const _hoisted_147 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_148 = { class: "mt-4 space-y-4" };
const _hoisted_149 = { class: "flex items-start" };
const _hoisted_150 = { class: "h-5 flex items-center" };
const _hoisted_151 = ["disabled", "checked"];
const _hoisted_152 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "payroll-frequency-monthly",
        class: "font-medium text-gray-700"
    }, "Monthly")
], -1);
const _hoisted_153 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_154 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "contract-type-input",
                                value: _ctx.formData.contractType,
                                name: "contractType",
                                autocomplete: "name",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        'error-border': _ctx.v$.formData.contractType.$error,
                                        'border-red-500': _ctx.v$.formData.contractType.$error,
                                    }]),
                                disabled: _ctx.showApprovalSteps,
                                onChange: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.contractType.$touch()))
                            }, [
                                (_ctx.showApprovalSteps)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configData.CONTRACTS, (type) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: type.ID,
                                            value: type.ContractType
                                        }, _toDisplayString(type.ContractType), 9, _hoisted_8));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeContracts, (type) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: type.ID,
                                            value: type.ContractType
                                        }, _toDisplayString(type.ContractType), 9, _hoisted_9));
                                    }), 128))
                            ], 42, _hoisted_7),
                            _createTextVNode(),
                            (_ctx.v$.formData.contractType.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "\n                * " + _toDisplayString(_ctx.v$.formData.contractType.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "contract-level-input",
                                value: _ctx.formData.contractLevel,
                                name: "contractLevel",
                                autocomplete: "name",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        'error-border': _ctx.v$.formData.contractLevel.$error,
                                        'border-red-500': _ctx.v$.formData.contractLevel.$error,
                                    }]),
                                disabled: _ctx.showApprovalSteps,
                                onChange: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.contractLevel.$touch()))
                            }, [
                                (_ctx.showApprovalSteps)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.contractLevels, (cl) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: cl.Contract,
                                            value: cl.ContractName
                                        }, _toDisplayString(cl.ContractName), 9, _hoisted_15));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeContractLevels, (cl) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: cl.Contract,
                                            value: cl.ContractName
                                        }, _toDisplayString(cl.ContractName), 9, _hoisted_16));
                                    }), 128))
                            ], 42, _hoisted_14),
                            _createTextVNode(),
                            (_ctx.v$.formData.contractLevel.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "\n                * " + _toDisplayString(_ctx.v$.formData.contractLevel.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _hoisted_18
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_19, [
                        (_ctx.currentContractLevel)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("p", _hoisted_21, [
                                    _hoisted_22,
                                    _createTextVNode(_toDisplayString(_ctx.currentContractLevel.PensionScheme), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_23, [
                                    _hoisted_24,
                                    _createTextVNode(_toDisplayString(_ctx.currentContractLevel.LifeCover), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_25, [
                                    _hoisted_26,
                                    _createTextVNode(" " + _toDisplayString(_ctx.currentContractLevel.PMI), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_27, [
                                    _hoisted_28,
                                    _createTextVNode(_toDisplayString(_ctx.currentContractLevel.Car), 1),
                                    _hoisted_29,
                                    _createTextVNode(),
                                    (_ctx.carAllowance)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, "\n                  A car allowance can be offered if preferred or if the contract\n                  is < 12 months in duration\n                "))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_31, [
                                    _hoisted_32,
                                    _createTextVNode(_toDisplayString(_ctx.currentContractLevel.Bonus), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_33, [
                                    _hoisted_34,
                                    _createTextVNode(" " + _toDisplayString(_ctx.currentContractLevel.OvertimeEligibility), 1),
                                    _hoisted_35,
                                    _createTextVNode(),
                                    (_ctx.currentContractLevel.OvertimeNote)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.currentContractLevel.OvertimeNote), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_37, [
                                    _hoisted_38,
                                    _createTextVNode(_toDisplayString(_ctx.currentContractLevel.Holidays), 1),
                                    _hoisted_39
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_40, [
                                    _hoisted_41,
                                    _createTextVNode(_toDisplayString(_ctx.currentContractLevel.Sickness), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_42, [
                                    _hoisted_43,
                                    _createTextVNode(_toDisplayString(_ctx.currentContractLevel.ProbationPeriod), 1)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("p", _hoisted_44, [
                                    _hoisted_45,
                                    _createTextVNode(_toDisplayString(_ctx.currentContractLevel.NoticePeriod), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    (_ctx.businessCar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("fieldset", _hoisted_47, [
                                _hoisted_48,
                                _createTextVNode(),
                                (_ctx.v$.formData.businessVehicle.$errors.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, "\n                * " + _toDisplayString(_ctx.v$.formData.businessVehicle.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                                _createElementVNode("input", {
                                                    id: "business-vehicle-car",
                                                    name: "businessVehicle",
                                                    type: "radio",
                                                    value: "Car",
                                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                        }]),
                                                    disabled: _ctx.showApprovalSteps,
                                                    checked: _ctx.formData.businessVehicle === 'Car',
                                                    onChange: _cache[4] || (_cache[4] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.businessVehicle.$touch()))
                                                }, null, 42, _hoisted_53)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_54
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("div", _hoisted_56, [
                                                _createElementVNode("input", {
                                                    id: "business-vehicle-van",
                                                    name: "businessVehicle",
                                                    type: "radio",
                                                    value: "Van",
                                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                        }]),
                                                    disabled: _ctx.showApprovalSteps,
                                                    checked: _ctx.formData.businessVehicle === 'Van',
                                                    onChange: _cache[6] || (_cache[6] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.businessVehicle.$touch()))
                                                }, null, 42, _hoisted_57)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_58
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_59, [
                                            _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("input", {
                                                    id: "business-vehicle-neither",
                                                    name: "businessVehicle",
                                                    type: "radio",
                                                    value: "Neither",
                                                    class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                        }]),
                                                    disabled: _ctx.showApprovalSteps,
                                                    checked: _ctx.formData.businessVehicle === 'Neither',
                                                    onChange: _cache[8] || (_cache[8] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                    onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.businessVehicle.$touch()))
                                                }, null, 42, _hoisted_61)
                                            ]),
                                            _createTextVNode(),
                                            _hoisted_62
                                        ])
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.bonusType)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_63,
                            _createTextVNode(),
                            _hoisted_64,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "bonusType",
                                value: _ctx.formData.bonusType,
                                name: "bonusType",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                onChange: _cache[10] || (_cache[10] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bonusTypes, (bt) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: bt,
                                        value: bt
                                    }, _toDisplayString(bt), 9, _hoisted_66));
                                }), 128))
                            ], 40, _hoisted_65)
                        ], 64))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("fieldset", _hoisted_68, [
                            _hoisted_69,
                            _createTextVNode(),
                            (_ctx.v$.formData.salaryBasis.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_70, "\n                * " + _toDisplayString(_ctx.v$.formData.salaryBasis.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_72, [
                                        _createElementVNode("div", _hoisted_73, [
                                            _createElementVNode("input", {
                                                id: "radio-basis-per-annum",
                                                name: "salaryBasis",
                                                type: "radio",
                                                value: "Per Annum",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.salaryBasis === 'Per Annum',
                                                onChange: _cache[11] || (_cache[11] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[12] || (_cache[12] = ($event) => (_ctx.v$.formData.salaryBasis.$touch()))
                                            }, null, 42, _hoisted_74)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_75
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_76, [
                                        _createElementVNode("div", _hoisted_77, [
                                            _createElementVNode("input", {
                                                id: "radio-basis-per-hour",
                                                name: "salaryBasis",
                                                type: "radio",
                                                value: "Per Hour",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.salaryBasis === 'Per Hour',
                                                onChange: _cache[13] || (_cache[13] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[14] || (_cache[14] = ($event) => (_ctx.v$.formData.salaryBasis.$touch()))
                                            }, null, 42, _hoisted_78)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_79
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                            _hoisted_82,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_83, [
                                _createElementVNode("input", {
                                    id: "minimum-pay-rate-input",
                                    value: _ctx.formData.minimumPayRate,
                                    type: "number",
                                    min: "0",
                                    name: "minimumPayRate",
                                    class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            'error-border': _ctx.v$.formData.minimumPayRate.$error,
                                            'border-red-500': _ctx.v$.formData.minimumPayRate.$error,
                                        }]),
                                    disabled: _ctx.showApprovalSteps,
                                    onInput: _cache[15] || (_cache[15] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                    onBlur: _cache[16] || (_cache[16] = ($event) => (_ctx.v$.formData.minimumPayRate.$touch()))
                                }, null, 42, _hoisted_84),
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    value: _ctx.formData.minimumPayRateCurrency,
                                    name: "minimumPayRateCurrency",
                                    class: "mt-1 ml-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onChange: _cache[17] || (_cache[17] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, [
                                    _hoisted_86,
                                    _createTextVNode(),
                                    _hoisted_87,
                                    _createTextVNode(),
                                    _hoisted_88
                                ], 40, _hoisted_85)
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.minimumPayRate.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_89, "\n                * " + _toDisplayString(_ctx.v$.formData.minimumPayRate.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                            _hoisted_92,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("input", {
                                    id: "maximum-pay-rate-input",
                                    value: _ctx.formData.maximumPayRate,
                                    type: "number",
                                    min: "0",
                                    name: "maximumPayRate",
                                    class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                            'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            'error-border': _ctx.v$.formData.maximumPayRate.$error,
                                            'border-red-500': _ctx.v$.formData.maximumPayRate.$error,
                                        }]),
                                    disabled: _ctx.showApprovalSteps,
                                    onInput: _cache[18] || (_cache[18] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                    onBlur: _cache[19] || (_cache[19] = ($event) => (_ctx.v$.formData.maximumPayRate.$touch()))
                                }, null, 42, _hoisted_94),
                                _createTextVNode(),
                                _createElementVNode("select", {
                                    value: _ctx.formData.maximumPayRateCurrency,
                                    name: "maximumPayRateCurrency",
                                    class: "mt-1 ml-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onChange: _cache[20] || (_cache[20] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                                }, [
                                    _hoisted_96,
                                    _createTextVNode(),
                                    _hoisted_97,
                                    _createTextVNode(),
                                    _hoisted_98
                                ], 40, _hoisted_95)
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.maximumPayRate.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_99, "\n                * " + _toDisplayString(_ctx.v$.formData.maximumPayRate.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("fieldset", _hoisted_101, [
                            _hoisted_102,
                            _createTextVNode(),
                            (_ctx.v$.formData.additionalAllowances.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_103, "\n                * " + _toDisplayString(_ctx.v$.formData.additionalAllowances.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_104, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_105, [
                                        _createElementVNode("div", _hoisted_106, [
                                            _createElementVNode("input", {
                                                id: "radio-additional-allowances-yes",
                                                name: "additionalAllowances",
                                                type: "radio",
                                                value: "Yes",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.additionalAllowances === 'Yes',
                                                onChange: _cache[21] || (_cache[21] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[22] || (_cache[22] = ($event) => (_ctx.v$.formData.additionalAllowances.$touch()))
                                            }, null, 42, _hoisted_107)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_108
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_109, [
                                        _createElementVNode("div", _hoisted_110, [
                                            _createElementVNode("input", {
                                                id: "radio-additional-allowances-no",
                                                name: "additionalAllowances",
                                                type: "radio",
                                                value: "No",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.additionalAllowances === 'No',
                                                onChange: _cache[23] || (_cache[23] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[24] || (_cache[24] = ($event) => (_ctx.v$.formData.additionalAllowances.$touch()))
                                            }, null, 42, _hoisted_111)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_112
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.model.additionalAllowances === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.additionalAllowancesInformation, (aa, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: aa,
                                    class: "p-2 m-4 border border-gray-200 rounded"
                                }, [
                                    _createElementVNode("div", _hoisted_114, [
                                        _createElementVNode("div", _hoisted_115, [
                                            _hoisted_116,
                                            _createTextVNode(),
                                            (index !== 0)
                                                ? (_openBlock(), _createBlock(_component_XIcon, {
                                                    key: 0,
                                                    class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer",
                                                    onClick: _withModifiers(($event) => (_ctx.removeAllowance(index)), ["prevent"])
                                                }, null, 8, ["onClick"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("select", {
                                            id: "aspecify",
                                            name: "additionalAllowancesInformation",
                                            autocomplete: "specify",
                                            value: aa.additionalAllowancesInformation,
                                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                            onChange: ($event) => (_ctx.handleAllowanceChange($event, index))
                                        }, [
                                            _hoisted_118,
                                            _createTextVNode(),
                                            _hoisted_119,
                                            _createTextVNode(),
                                            _hoisted_120,
                                            _createTextVNode(),
                                            _hoisted_121,
                                            _createTextVNode(),
                                            _hoisted_122,
                                            _createTextVNode(),
                                            _hoisted_123,
                                            _createTextVNode(),
                                            _hoisted_124,
                                            _createTextVNode(),
                                            _hoisted_125,
                                            _createTextVNode(),
                                            _hoisted_126,
                                            _createTextVNode(),
                                            _hoisted_127,
                                            _createTextVNode(),
                                            _hoisted_128,
                                            _createTextVNode(),
                                            _hoisted_129,
                                            _createTextVNode(),
                                            _hoisted_130,
                                            _createTextVNode(),
                                            _hoisted_131
                                        ], 40, _hoisted_117)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_132, [
                                        _createElementVNode("div", _hoisted_133, [
                                            _createElementVNode("div", _hoisted_134, [
                                                _hoisted_135,
                                                _createTextVNode(),
                                                _createElementVNode("input", {
                                                    id: "additional-allowance-amount",
                                                    value: aa.additionalAllowanceAmount,
                                                    type: "number",
                                                    min: "0",
                                                    name: "additionalAllowanceAmount",
                                                    autocomplete: "name",
                                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                                    onInput: ($event) => (_ctx.handleAllowanceChange($event, index))
                                                }, null, 40, _hoisted_136)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_137, [
                                                _hoisted_138,
                                                _createTextVNode(),
                                                _createElementVNode("select", {
                                                    id: "aspecify",
                                                    name: "additionalAllowancesCurrency",
                                                    autocomplete: "specify",
                                                    value: aa.additionalAllowancesCurrency,
                                                    class: "mt-1 w-24 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                                    onChange: ($event) => (_ctx.handleAllowanceChange($event, index))
                                                }, [
                                                    _hoisted_140,
                                                    _createTextVNode(),
                                                    _hoisted_141,
                                                    _createTextVNode(),
                                                    _hoisted_142
                                                ], 40, _hoisted_139)
                                            ])
                                        ])
                                    ])
                                ]));
                            }), 128)),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_143, [
                                _createElementVNode("button", {
                                    class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                    onClick: _cache[25] || (_cache[25] = _withModifiers(
                                    //@ts-ignore
                                    (...args) => (_ctx.addAllowance && _ctx.addAllowance(...args)), ["prevent"]))
                                }, "\n                Add allowance +\n              ")
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_144, [
                        _createElementVNode("fieldset", _hoisted_145, [
                            _hoisted_146,
                            _createTextVNode(),
                            (_ctx.v$.formData.payrollFrequency.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_147, "\n                * " + _toDisplayString(_ctx.v$.formData.payrollFrequency.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_148, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_149, [
                                        _createElementVNode("div", _hoisted_150, [
                                            _createElementVNode("input", {
                                                id: "radio-payroll-frequency-monthly",
                                                name: "payrollFrequency",
                                                type: "radio",
                                                value: "Monthly",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                    }]),
                                                disabled: _ctx.showApprovalSteps,
                                                checked: _ctx.formData.payrollFrequency === 'Monthly',
                                                onChange: _cache[26] || (_cache[26] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                                onBlur: _cache[27] || (_cache[27] = ($event) => (_ctx.v$.formData.payrollFrequency.$touch()))
                                            }, null, 42, _hoisted_151)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_152
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            (!_ctx.showApprovalSteps)
                ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                    _createElementVNode("button", {
                        class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        onClick: _cache[28] || (_cache[28] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                    }, "\n          Reset Form\n        "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[29] || (_cache[29] =
                            //@ts-ignore
                            (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                    }, "\n          Next\n        ", 8, _hoisted_154)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
